import { Fragment, useRef, useState } from "react";
import classes from "./Account.module.css";
import Header from "../../Header&Footer/Header";
import { useContext } from "react";
import { CartContext } from "../../../CartContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import EyeIcon from "../../ui/EyeIcon";

const isEmpty = (value) => value.trim() === "";
const isEmail = (value) => value.trim().includes("@");
const is6CharLong = (value) => value.trim().length >= 6;

const Login = (props) => {
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(true);
  const navigate = useNavigate();
  const login = useContext(CartContext);
  const [error, setError] = useState(false);
  const [formInputValidity, setFormInputValidity] = useState({
    email: true,
    password: true,
  });

  const emailRef = useRef();
  const passwordRef = useRef();

  const loginFormHandler = (e) => {
    e.preventDefault();
    const enteredEmail = emailRef.current.value;
    const enteredPassword = passwordRef.current.value;

    const enteredEmailIsValid = isEmail(enteredEmail);
    const enteredPasswordIsValid =
      is6CharLong(enteredPassword) && !isEmpty(enteredPassword);

    setFormInputValidity({
      email: enteredEmailIsValid,
      password: enteredPasswordIsValid,
    });

    const formIsValid = enteredEmailIsValid && enteredPasswordIsValid;
    if (!formIsValid) {
      return;
    }
    props.isLoading(true);
    // fetch(
    //   "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
    //   {
    //     method: "POST",
    //     body: JSON.stringify({
    //       email: enteredEmail,
    //       password: enteredPassword,
    //       returnSecureToken: true,
    //     }),
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //   }
    // )
    //   .then((response) => {
    //     if (response.ok) {
    //       props.isLoading(false);
    //       return response.json();
    //     } else {
    //       props.isLoading(false);
    //       return response.json().then((data) => {
    //         throw new Error(data.error.errors[0].message);
    //       });
    //     }
    //   })
    //   .then((data) => {
    //     console.log(login.localID(data.localId));
    //     login.login(data.idToken);
    //     navigate("/");
    //   })
    //   .catch((err) => {
    //     setError(err.message);
    //   });
    props.onLogin(enteredEmail, enteredPassword);
  };
  function toggleHandler() {
    if (type === "password") {
      setType("text");
      setIcon(false);
    } else {
      setType("password");
      setIcon(true);
    }
  }

  return (
    <Fragment>
      <Header />
      <div className={classes.body}>
        <div className={classes.form}>
          <h1>Login in and start dripping!</h1>
          <form onSubmit={loginFormHandler}>
            <div className={classes.detail}>
              <label htmlFor="email">Email</label>
              <input ref={emailRef} id="email" type="email" />
              {!formInputValidity.email && (
                <p className="invalid">
                  Please Enter a Valid Email (test@email.com)
                </p>
              )}
            </div>
            <div className={classes.detail}>
              <label htmlFor="pin">Enter Password</label>
              <input ref={passwordRef} id="pin" type={type} />
              <EyeIcon icon={icon} toggleHandler={toggleHandler} />
            </div>
            {props.error && <p className="invalid">{props.error}</p>}
            <div className={classes.action}>
              <p>
                Don't have an account? <Link to="/register">Sign Up Here</Link>
              </p>
              <p>
                Forgot Password? <Link to="/reset">Reset</Link>
              </p>
              <button>{props.loading ? "Loading..." : "Log In"}</button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
